import CustomViewDialogStore from "csi/middleware/customView/CustomViewDialogStore";
import { createAttributesStore } from "csi/service/viewService";
import CustomViewController from "csi/view/CustomViewController";
import { ILocaleProvider } from "designSystem/locale";
import declare from "dojo/_base/declare";

const PropertyCustomViewController = declare(CustomViewController, {
	/**
	 * @override
	 * Populate the stores available for property views
	 */
	onCreateStore(loc: ILocaleProvider, store: CustomViewDialogStore): void {
		store.attributesStore = createAttributesStore(this.widget, loc);
	},
});

export = PropertyCustomViewController;